module.exports = __webpack_public_path__ + "img/video_title.a2c32497.png";